import React, { useEffect } from "react";
import ChartLoader from "../../components/chartLoader/chartLoader";
import VerticalBarChartDataLabels from "../../components/charts/verticalBarChartDataLabels";
// import NoDataChartContainer from "../../../../components/NoDataFoundChart/NoDataFoundChart";
import Selector from "../../components/select/select";
import { StudentAd2Card } from "./ad2Card";
import { Ad2SelectorWrapper } from "../styles/Ad2Styles";
import { useTranslation } from "react-i18next";
import { NotCompleteText } from "./commonStyles";
import { useDispatch } from "react-redux";
import { updateImageBase } from "./imageReducer";
const columns = [
  {
    name: "",
    selectorKey: "type",
    selector: (row) => row.type,
    sortable: false,
  },
  {
    name: "Male",
    selectorKey: "male",
    selector: (row) => row.male,
    sortable: false,
  },
  {
    name: "Female",
    selectorKey: "female",
    selector: (row) => row.female,
    sortable: false,
  },
];

export function Ad2StudentWorkValues({ data,
  studentWorkInterestFilter,
  setStudentWorkInterestFilterFilter,
  onViewMoreClick,
}) {
  
  const chartData = data;
  const gridData = data && data.gridData;
  const status = data && data.status;
      const chartRef = React.useRef(null);
       const dispatch = useDispatch();
  function RightContent() {
    const ranks = [
      "Rank 1",
      "Rank 2",
      "Rank 3",
    ].map((item) => {
      return { value: item, label: item };
    });

          useEffect(() =>{
        const chartInstance = chartRef.current;
    
        // Ensure chart has rendered
        setTimeout(() => {
          if (chartInstance && chartInstance.canvas) {
         
  const base64Image = chartInstance.canvas.toDataURL("image/png");
            dispatch(updateImageBase({name:"work_values",value:base64Image}))
            
          
          }
        }, 1000);
      },[chartData]);
    return (
      <Ad2SelectorWrapper>
        <Selector
          onChange={(value) => {
            setStudentWorkInterestFilterFilter(value);
          }} options={ranks} defaultValue={{ value: studentWorkInterestFilter, label: studentWorkInterestFilter }} />
      </Ad2SelectorWrapper>
    );
  }
  const { t, i18n } = useTranslation();
  return (
    <>
      {
        chartData?.status !== "noDataFound"
        ?
      
      chartData?.Mastery?.points
        ? <StudentAd2Card
          title={t("Work Values")}
          data={gridData}
          columns={columns}
          exportFileName="students_work_interest"
          rightContent={<RightContent />}
          status={status}
          onViewMoreClick={onViewMoreClick}
        >
          <VerticalBarChartDataLabels
          chartType={"work_values"}
            data={{
              labels: [
                t("Creating Value"),
                t("Fellowship"),
                t("Mastery"),
                t("Quality of Life"),
              ],
              datasets: [
                {
                  // data: [20,23,15,28,24,8,21],
                  data: [
                    chartData && chartData['Creating Value'] && chartData['Creating Value'].points,
                    chartData && chartData['Fellowship'] && chartData['Fellowship'].points,
                    chartData && chartData['Mastery'] && chartData['Mastery'].points,
                    chartData && chartData['Quality of Life'] && chartData['Quality of Life'].points,
                    // chartData && chartData.Enterprising && chartData.Enterprising.points,
                    // chartData && chartData.Conventional && chartData.Conventional.points,
                  ], //this code is working. remove dummy data if needed.
                  backgroundColor: "#004B84",
                  borderRadius: Number.MAX_VALUE,
                  borderSkipped: false,
                  borderColor: "rgba(0,0,0,0)",
                  barPercentage: 1,
                  categoryPercentage: 0.8,
                }
              ],
            }}
          />
        </StudentAd2Card>
        : <ChartLoader></ChartLoader>
      
        : <div  className="noFound">
        <NotCompleteText style={{ margin: 0 }}>{t("Not Completed")}</NotCompleteText>
      </div >
      }

    </>
  );
}